import React from "react";

// Shared session-rating calculation + display so the average rating is computed
// and rendered identically everywhere (admin Session Log page, Progress Report,
// and the tutor Session Workspace "Recent Sessions" table).

const RATING_KEYS = ["effort", "motivation", "behavior", "focus", "confidence"];

// Average of all non-null, non-zero ratings stored under log.ratings.
// Returns null when there are no usable ratings.
export function calcAvgRating(log) {
  const vals = RATING_KEYS
    .map((k) => {
      const v = log?.ratings?.[k];
      if (v == null || v === "") return null;
      const n = Number(v);
      return Number.isFinite(n) && n > 0 ? n : null;
    })
    .filter((v) => v !== null);
  if (!vals.length) return null;
  return Math.round((vals.reduce((s, v) => s + v, 0) / vals.length) * 10) / 10;
}

// Partial-fill star display with the numeric average underneath.
// Self-contained styling (no external CSS dependency) so it looks identical
// regardless of which stylesheet the host page loads.
export function StarRating({ value, uid }) {
  if (!Number.isFinite(value)) {
    return <span style={{ color: "#94a3b8", fontSize: 13 }}>—</span>;
  }
  const MAX = 5;
  const STAR_W = 12;
  const GAP = 1;
  const totalW = MAX * (STAR_W + GAP) - GAP;
  const fillW = Math.max(0, Math.min(totalW, (value / MAX) * totalW));
  const clipId = `srx${uid ? `-${uid}` : ""}-${String(value).replace(".", "_")}`;
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 2, lineHeight: 1 }}>
      <svg width={totalW} height={STAR_W} style={{ display: "block" }}>
        <defs>
          <clipPath id={clipId}>
            <rect x={0} y={0} width={fillW} height={STAR_W} />
          </clipPath>
        </defs>
        {[0, 1, 2, 3, 4].map((i) => (
          <text key={i} x={i * (STAR_W + GAP) + 5} y={STAR_W - 0.5} textAnchor="middle" fontSize={STAR_W} fill="#e2e8f0">★</text>
        ))}
        <g clipPath={`url(#${clipId})`}>
          {[0, 1, 2, 3, 4].map((i) => (
            <text key={i} x={i * (STAR_W + GAP) + 5} y={STAR_W - 0.5} textAnchor="middle" fontSize={STAR_W} fill="#f59e0b">★</text>
          ))}
        </g>
      </svg>
      <span style={{ fontSize: 10, color: "#94a3b8", fontWeight: 500, lineHeight: 1 }}>{value.toFixed(1)}</span>
    </div>
  );
}
